import type { ProfileCatalogLane } from "@x12i/ai-profiles";

export type { ProfileCatalogLane };

/** Default OpenRouter lane for token-priced LLM usage in this package. */
export const TEXT_CATALOG_LANE: ProfileCatalogLane = "text";
